import _bundle from '../../../../core/core--bundles';
import { _g } from '../../../../core/core--base';

const { _bp } = _g;

export default function() {
    _bundle.add({
        name: 'Form Footer Width Helper',
        event: ['on:BundleReady', 'on:ResizeDefault', 'on:PageUpdate'],
        fn() {
            const $contentElement = $('#content');
            // Padding Offset
            const $formFooter = $('.form-footer');
            if ($formFooter.length) {
                $contentElement.css('padding-bottom', $formFooter.outerHeight());
                // Width Desktop Only
                if (_bp.match('laptop', 'up')) {
                    $formFooter.width($contentElement.width());
                } else {
                    $formFooter.css('width', '');
                }
            }
        }
    });
}
